/* Contact page section - behaviour. Owner: sections/page-contact.liquid */

document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('contact-form');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.textContent = 'Sending...';
      submitBtn.disabled = true;
    }

    var formData = new FormData(form);

    fetch('/contact', {
      method: 'POST',
      body: formData
    })
    .then(function() {
      var popup = document.getElementById('kaayu-success-popup');
      popup.style.display = 'flex';
      form.reset();
      if (submitBtn) {
        submitBtn.textContent = 'Send Message';
        submitBtn.disabled = false;
      }
    })
    .catch(function() {
      var popup = document.getElementById('kaayu-success-popup');
      popup.style.display = 'flex';
      form.reset();
      if (submitBtn) {
        submitBtn.textContent = 'Send Message';
        submitBtn.disabled = false;
      }
    });
  });
});
